import React, { useState, CSSProperties } from "react";
import Video from "../../Video/video.mp4";
import HeroContent from "./HeroContent";
import HeroBanner from "./HeroBanner";
import RingLoader from "react-spinners/RingLoader";

const HeroSection = ({ pointer }) => {
	const [isVideoLoaded, setIsVideoLoaded] = useState(false);
	return (
		/* -------------------------------------------------------------------------- */
		/*                             Main Hero Container                            */
		/* -------------------------------------------------------------------------- */
		<div
			id="hero"
			ref={pointer}
			className="bg-[#0c0c0c] flex flex-col justify-center items-center py-0 px-7 h-[800px] relative z-10 "
		>
			{/* ----------------------------- Video Background ---------------------------- */}
			<div className="absolute inset-0 w-full h-full overflow-hidden ">
				<video
					autoPlay
					loop
					muted
					className="w-full h-full object-cover bg-[#232a34]  "
					onLoadedData={() => setIsVideoLoaded(true)}
				>
					<source
						src="https://ik.imagekit.io/kaifurrahman/DSC%20Website/heroSectionAsset.mp4?updatedAt=1698243808379import"
						type="video/mp4"
					/>
				</video>
			</div>
			{!isVideoLoaded && (
				<div className="absolute inset-0 flex justify-center items-center bg-black">
					<RingLoader
						color="#4be4c0"
						loading
						size={80}
						speedMultiplier={1}
					/>
				</div>
			)}
			{/* ---------------------------- Hero Banner/Logo ---------------------------- */}
			{isVideoLoaded && <HeroBanner />}

			{/* ------------------------------ Hero Content ------------------------------ */}
			{isVideoLoaded && <HeroContent />}
		</div>
	);
};

export default HeroSection;
